import AuthService from '../../service';
const DesignWorldCalendar = {
  getDesignWorldCalendar(page,search,sort_date,sort_column){
    return AuthService.get(`/design_world_calendar?page=${page}&search=${search}&sort_date=${sort_date}&sort_column=${sort_column}`);
  },
  showDesignWorldCalendar(id){
    return AuthService.get(`design_world_calendar/${id}`);
  },
  createDesignWorldCalendar(data){
    return AuthService.post(`design_world_calendar`,data);

  },
  updateDesignWorldCalendar(id,data){
    return AuthService.put(`design_world_calendar/${id}`,data);

  },
  deleteDesignWorldCalendar(id){
    return AuthService.delete(`design_world_calendar/${id}`);

  },
}
export default DesignWorldCalendar
